"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentTagsSchema = exports.ExperimentTagSchema = exports.ExperimentTagName = void 0;
const z = require("zod");
var ExperimentTagName;
(function (ExperimentTagName) {
    ExperimentTagName["Tracked"] = "Tracked";
    ExperimentTagName["Deployed"] = "Deployed";
})(ExperimentTagName || (exports.ExperimentTagName = ExperimentTagName = {}));
const TrackedTagMetadataSchema = z.object({
    explanation: z.string(),
});
const DeployedTagMetadataSchema = z.object({
    pullRequest: z
        .string()
        .regex(/^[0-9]{4,5}$/, 'pullRequest must be a 4-5 digit numeric string')
        .optional(),
});
const TrackedTagSchema = z.object({
    name: z.literal(ExperimentTagName.Tracked),
    metadata: TrackedTagMetadataSchema,
});
const DeployedTagSchema = z.object({
    name: z.literal(ExperimentTagName.Deployed),
    metadata: DeployedTagMetadataSchema,
});
exports.ExperimentTagSchema = z.discriminatedUnion('name', [
    TrackedTagSchema,
    DeployedTagSchema,
]);
exports.ExperimentTagsSchema = z.array(exports.ExperimentTagSchema);
//# sourceMappingURL=experiment-tags.js.map